import { Sparkles } from "lucide-react";

const ITEMS = [
  "Residential Deep Cleaning",
  "Commercial & Office Sanitization",
  "Sofa & Carpet Shampooing",
  "Kitchen & Washroom Detailing",
  "Post-Construction Cleanup",
  "4.9★ Rated on Google",
  "Siliguri · North Bengal",
];

export default function Marquee() {
  return (
    <div data-testid="editorial-marquee" className="overflow-hidden bg-sapphire-ink py-4">
      <div className="marquee-track flex w-max items-center">
        {[...ITEMS, ...ITEMS].map((t, i) => (
          <span
            key={i}
            className="flex items-center gap-8 pr-8 text-xs font-bold uppercase tracking-[0.25em] text-white/75 sm:text-sm"
          >
            {t}
            <Sparkles className="h-4 w-4 shrink-0 text-whatsapp" />
          </span>
        ))}
      </div>
    </div>
  );
}
